export default __webpack_public_path__ + "static/media/harvard-university-cambridge-usa@2x.38219b7d.png";